import { PageLoading } from 'module/ui/components/atoms/loading';
import { Page } from 'module/ui/components/molecules/page';
import { Argon as ArgonTemplate } from 'module/ui/components/templates/argon';
import { PageType } from 'api/page-template/types';
import { useGetDocumentFeedbackQuery } from 'queries/feedback';
import { useGetDocumentQuery } from 'queries/pages';
import { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Document } from 'components/organisms/document/document';
import { DocumentPageHeaderActions } from 'components/organisms/document/header-action';
import { DocumentPageHeaderTitle } from 'components/organisms/document/title';
import { CollaborationUser } from 'components/organisms/document-editor/collaborative-editor';
import { ExtensionConfig } from 'components/organisms/document-editor/types';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const Argon = styled(ArgonTemplate)<{ distractionFreeState: boolean }>`
  ${Page.Header} {
    animation: ${({ distractionFreeState }) =>
      distractionFreeState
        ? css`
            ${fadeOut} 0.5s ease-in-out forwards
          `
        : css`
            ${fadeIn} 0.5s ease-in-out forwards
          `};
  }
`;

interface DocumentPageProps {
  documentId: number;
  editorExtensionsConfig?: Partial<ExtensionConfig>;
  onBack: () => void;
  pageType?: PageType;
}
export const DocumentPage = ({
  documentId,
  editorExtensionsConfig,
  onBack,
  pageType,
}: DocumentPageProps) => {
  const [activeUsersFromCollaboration, setActiveUsersFromCollaboration] =
    useState<CollaborationUser[]>([]);
  const { data: document, isLoading: isDocumentLoading } =
    useGetDocumentQuery(documentId);
  const { isLoading: isFeedbackLoading } = useGetDocumentFeedbackQuery(
    'DOCUMENT',
    documentId.toString(),
  );
  const isLoading = isDocumentLoading || document == null;
  const [distractionFreeState, setDistractionFreeState] = useState(false);

  return isLoading || isFeedbackLoading ? (
    <PageLoading />
  ) : (
    <Argon
      distractionFreeState={distractionFreeState}
      title={<DocumentPageHeaderTitle document={document} onBack={onBack} />}
      pageActions={
        <DocumentPageHeaderActions
          document={document}
          activeUsersFromCollaboration={activeUsersFromCollaboration}
        />
      }
      actions={{}}
      showHeaderBorder={false}
      content={
        <Document
          document={document}
          readonly={false}
          onDistractionFreeStateChange={setDistractionFreeState}
          editorExtensionsConfig={editorExtensionsConfig}
          onActiveUsersFromCollaborationChange={setActiveUsersFromCollaboration}
          pageType={pageType}
        />
      }
    />
  );
};
